import { ObservableArray, View } from "binder"
import { ThemeSelectorViewModel } from "src/common/themeSelector/themeSelector-viewModel";
import { FilterAccessibleFormsViewModel, UserMainWindowViewModel } from "../userMainWindow-viewModel";
import { WindowContainerViewModel } from "../windowContainer/windowContainer-viewModel";

export class UserMainWindowPhoneView extends View<UserMainWindowViewModel>{
    GetViewUniqueId(): string {
        return "V-09A457C1-2847-437E-9591-AC22A407B3EC"
    }
    loadHtml(): string {
        let element = require('./userMainWindowPhone.html').default;
        let style = require('./userMainWindowPhone.less');
        return element;
    }
    constructor() {
       super();
       this.thisClickedHandler = this.thisClicked.bind(this);
       this.windowClickedHandler = this.windowClicked.bind(this); 
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set forms(v: ObservableArray<WindowContainerViewModel>) { this._forms = v; } public get forms(): ObservableArray<WindowContainerViewModel> { return this._forms;} private _forms: ObservableArray<WindowContainerViewModel>;
    public set currentForm(v: WindowContainerViewModel) { 
        this._currentForm = v; 
        this.isShowingMenu = false;
        if(this.currentForm!=null && this.forms.length>1){
            this.forms.shift();
        }
    } public get currentForm(): WindowContainerViewModel { return this._currentForm;} private _currentForm: WindowContainerViewModel;
    public set filter(v: FilterAccessibleFormsViewModel) { this._filter = v; } public get filter(): FilterAccessibleFormsViewModel { return this._filter;} private _filter: FilterAccessibleFormsViewModel;
    public set loggedInPersonnelName(v: string) { this._loggedInPersonnelName = v; } public get loggedInPersonnelName(): string { return this._loggedInPersonnelName;} private _loggedInPersonnelName: string;
    public set loggedInPersonnelCode(v: string) { this._loggedInPersonnelCode = v; } public get loggedInPersonnelCode(): string { return this._loggedInPersonnelCode;} private _loggedInPersonnelCode: string;
    public set autohide(v: boolean) { this._autohide = v; } public get autohide(): boolean { return this._autohide;} private _autohide: boolean;

    public set isShowingMenu(v: boolean) { this._isShowingMenu = v;this.updateEvents(); } public get isShowingMenu(): boolean { return this._isShowingMenu;} private _isShowingMenu: boolean;
    public set themeWindow(v: ThemeSelectorViewModel) { this._themeWindow = v; } public get themeWindow(): ThemeSelectorViewModel { return this._themeWindow;} private _themeWindow: ThemeSelectorViewModel;
    public set shallShowThemes(v: boolean) { this._shallShowThemes = v; } public get shallShowThemes(): boolean { return this._shallShowThemes;} private _shallShowThemes: boolean;
    
    toggleShowing(e:PointerEvent){
        this.isShowingMenu = !this.isShowingMenu;
        if(this.isShowingMenu){
            e?.stopPropagation();
        }
    }

    private thisClicked(e:PointerEvent){
        e.stopPropagation();
    }
    private windowClicked(e:PointerEvent){
        this.isShowingMenu = false;
        e.stopPropagation();
    }
    private thisClickedHandler;
    private windowClickedHandler;
    private menu:HTMLElement;
    updateEvents(){
        if(this.isShowingMenu){
            window.addEventListener("click",e=>this.windowClickedHandler(e));
            this.menu.addEventListener("click",e=>this.thisClickedHandler(e));

        }else{
            window.removeEventListener("click",this.windowClickedHandler);
            this.menu?.removeEventListener("click",this.thisClickedHandler);
        }
    }
    
    public onRenderCompleted() {
        this.menu = this.firstlevelElement.querySelector('.V-09A457C1-2847-437E-9591-AC22A407B3EC.menu');
        this.isShowingMenu = false;
    }
    
    showThemeWindow(){
        this.isShowingMenu = false;
        this.dataContext.showThemeWindow();
    }
}
